module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get_600.d311053.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/fullscreen-image_lets-get_600.png
// module id = yjV9
// module chunks = 0